import React from "react";

export const CommentTab = () => {
  return <div>CommentTab</div>;
};
